import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { authActions } from '@/store/slices/authSlice';

export default function AuthProvider({ children }) {
	const dispatch = useDispatch();
	const key = useSelector((state) => state.auth.key);
	const user = useSelector((state) => state.auth.user);
	const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

	useEffect(() => {
		// Only try to authenticate if we have the necessary data but aren't authenticated yet
		if (key && user && isAuthenticated === null) {
			dispatch(authActions.setAuthenticated());
		}
	}, [dispatch, key, user, isAuthenticated]);

	// Add loading state handling
	if (isAuthenticated === null && (key || user)) {
		return <div>Loading...</div>;
	}

	return children;
}
